import { computed } from 'vue'
import { useRoute } from 'vue-router'
import {
  isLiteIntegration,
  resolveIntegrationMode,
  type IntegrationMode,
} from '@/utils/integrationMode'

export function useIntegrationMode() {
  const route = useRoute()

  const mode = computed<IntegrationMode | null>(() => {
    void route.fullPath
    return resolveIntegrationMode()
  })

  const isLite = computed(() => isLiteIntegration(mode.value))

  return {
    mode,
    isLite,
  }
}
